import { makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { StandardDialog } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";
import { PayoffProtectiveAdvancesMoreInfo } from "./payoffProtectiveAdvancesMoreInfo";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffProtectiveAdvancesMoreInfoDialog = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <div>
      <StandardDialog
        open={payoffCalculatorStore.isProtectiveAdvancesMoreInfoDialogOpen}
        title="Receivables Allocation"
        maxWidth="md"
        handleClose={() => payoffCalculatorStore.setIsProtectiveAdvancesMoreInfoDialogOpen(false)}
        dialogContent={
          <PayoffProtectiveAdvancesMoreInfo />
        }
      />
    </div>
  );
});
